import { coreApi } from "./coreApi";

export const financialReportsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getBalanceSheet: builder.query({
      query: (filterQuery) => `/accounting/reports/balance-sheet?${filterQuery}`,
    }),
  }),
});

export const { useGetBalanceSheetQuery } = financialReportsApi;

export default financialReportsApi;
